import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { BusinessEnabledOption, KeyValues5, LocalService, PricingManagementInitialization, Status, TriggeredEvent } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';

@Component({
  selector: 'app-batch-pricing',
  templateUrl: './batch-pricing.component.html',
  styleUrl: './batch-pricing.component.scss'
})
export class BatchPricingComponent {
  @ViewChild('content_batch_pricing')
  content!: TemplateRef<any>;
  @Input() isOpen: boolean = false;
  @Output() isOpenChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["product_config"];
  @Input() productId: string = ''; @Input() batchId: string = ''; @Input() businessId: string = '';
  priceInitialization: PricingManagementInitialization; isNotConsiderTax: boolean = false; isShowDeleteConfirmation = false;
  isExcludePrice: boolean = false;
  businessTaxCategories: KeyValues5[] = []; selectedBusinessTaxCategoryId: string = '';

  elementIds: any = {
    save_product: 'btn_save_pricing',
    bring_primary_price: 'btn_bring_primary_price',
    delete_pricing: 'btn_delete_pricing'
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService) {
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.isNotConsiderTax = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.ConsiderBaseAmountAsTaxInCludedAmount)
  }

  ngOnChanges(): void {
    if (this.isOpen) {
      this.onReset();
      this.onLoad(this.batchId);
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right popup_overlay_medium',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpen = false;
    if (this.isOpenChange) {
      this.isOpenChange.emit(this.isOpen);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onReset() {
    this.isShowDeleteConfirmation = false;
    this.priceInitialization = undefined;
  }

  onLoad(batchId?: string) {
    this.isExcludePrice = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsExcludedPricingEnabled);
    this.productManagementService.getPricingManagment(this.businessId, this.productId, batchId, undefined, batchId && batchId.length > 3).subscribe(result => {
      if (!this.priceInitialization) {
        this.priceInitialization = result;
      } else {
        this.priceInitialization.pricings = result.pricings;
      }
    });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onLoad();
      } break;
      case 2: {
        this.onSave();
      } break;
      case 3: {
        this.isShowDeleteConfirmation = true;
      } break;
    }
  }

  onSave() {
    this.productManagementService.savePrice(this.priceInitialization.pricings, this.priceInitialization.pricingsExcluded, this.productId, this.batchId).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onCloseTrigger();
      }
    });
  }

  onCloseMessageBox(result) {
    if (result.event == TriggeredEvent.Ok) {
      this.productManagementService.deletePrice(this.productId, this.batchId).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.onCloseTrigger();
        }
      });
    }
    this.isShowDeleteConfirmation = false;
  }
}
